/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InProgressDocumentList } from '../../models/in-progress-document-list';

export interface VaultGetInProgressDocumentList$Params {

/**
 * GUID of the vault
 */
  vaultId: string;
}

export function vaultGetInProgressDocumentList(http: HttpClient, rootUrl: string, params: VaultGetInProgressDocumentList$Params, context?: HttpContext): Observable<StrictHttpResponse<InProgressDocumentList>> {
  const rb = new RequestBuilder(rootUrl, vaultGetInProgressDocumentList.PATH, 'get');
  if (params) {
    rb.path('vaultId', params.vaultId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InProgressDocumentList>;
    })
  );
}

vaultGetInProgressDocumentList.PATH = '/vault/{vaultId}/in-progress-document/list';
